export interface Alert {
  title?: string;
  message: any;
  type: string;
  onAccept?: Function;
  onCancel?: Function;
  onClose?: Function;
  onXButton?: boolean;
}

export enum TypeAlert {
  success = 'success',
  error = 'danger',
  warning = 'warning',
  question = 'answer',
  loader = 'loader',
}

export interface IInfoOtp {
  phoneContact: string
  idDn: string
}
